export default __webpack_public_path__ + "static/media/menuBtn.3bbe0ca1.png";